import { SbBlokData, storyblokEditable } from "@storyblok/js";

import type { MediaGalleryStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import sizes from "@/lib/utils/sizes";
import clsx from "clsx";
import styles from "./media-gallery.module.css";

const MediaGallery = ({
  blok,
  preview
}: {
  blok: MediaGalleryStoryblok;
  preview: boolean;
}) => {
  return (
    <div
      className={styles.root}
      {...storyblokEditable(blok as unknown as SbBlokData)}
    >
      <p className={styles.tag}>{blok.tag}</p>
      <h2 className={styles.title}>{blok.title}</h2>
      <div
        className={clsx(styles.cards, "scroll_container")}
        data-mobile-only
      >
        {blok.media?.map((media) => (
          <div className={styles.card__wrapper} key={media?._uid}>
            <div className={styles.card}>
              <StoryblokComponent
                blok={media}
                sizes={sizes(95, 33)}
                preview={preview}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MediaGallery;
